import PropTypes from 'prop-types';
import cx from 'classnames';

import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';

/**
 * Обтекаемые виджеты. Отслеживаем их для того, чтобы рядом с ними
 * не вставлять рекламу.
 */
const floatWidgets = {
  readMore: true,
};

const ampWidgetsWithNegativeMobileIndent = {
  'image': true,
  'sideBySide': true,
  'photoGallery': true,
  'galleryLink': true,
  'slides': true,
};


export default function Widget(props) {
  const {
    block,
    parentProps,
    ctx,
    renderer,
    position,
  } = props;

  const {
    theme: {
      controls: {
        topicContent: atoms,
      },
      layout: {
        indents: {
          // предполагаем, что на мобилке левый и правый отступы равны.
          // на практике это всегда так
          right: mobileSideIndent,
        },
      },
    },
    isDesktop,
    isMobile,
    amp,
  } = parentProps;

  const { type } = block;

  if (isDesktop && floatWidgets[type]) {
    ctx.lastFloatWidgetPosition = ctx.chars;
  }

  const widgetsWithNegativeMobileIndent = amp
    ? ampWidgetsWithNegativeMobileIndent
    : atoms.widgetsWithNegativeMobileIndent;

  const isWidgetWithMaxWidth = isDesktop
    && atoms.widgetsWithMaxWidth
    && atoms.widgetsWithMaxWidth[type];

  const isWidgetWithNegativeMobileIndent = isMobile
    && widgetsWithNegativeMobileIndent
    && widgetsWithNegativeMobileIndent[type];

  const topIndent = position ? atoms.widget.top + 'px' : 0;
  const bottomIndent = type === 'image' ? atoms.image.bottom : atoms.widget.bottom;
  const sideIndent = isWidgetWithNegativeMobileIndent ? -mobileSideIndent + 'px' : 'auto';
  const maxWidth = isWidgetWithMaxWidth ? atoms.widgetsMaxWidth + 'px' : 'none';

  return (
    <div className={cx('vikont', type !== 'markdown' && styles._clear)} data-qa='vikont'>
      <style jsx>{`
        .vikont
          margin ${topIndent} ${sideIndent} ${bottomIndent}px
          max-width ${maxWidth}
      `}</style>
      {renderer({ ...block, position }, parentProps, ctx)}
    </div>
  );
}

Widget.propTypes = {
  renderer: PropTypes.func.isRequired,
  block: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  parentProps: PropTypes.shape({
    breakpoint: breakpointPropTypes(),
    theme: themePropTypes(`{
      controls: {
        topicContent: {
          tableOfContents: {
            borderBottom,
            padding,
            margin,
            maxWidth,
            title: {
              font,
              color,
              display,
            },
          },
          widgetsMaxWidth,
          heading: {
            clear,
          },
        }
      },
    }`),
    isDesktop: PropTypes.bool,
    isMobile: PropTypes.bool,
    amp: PropTypes.bool,
  }),
  position: PropTypes.number,
  ctx: PropTypes.object,
};
